import React, {useState, useRef, useCallback, useEffect, Ref} from 'react';
import {DatePicker, FormInstance, message} from 'antd';
import config from './config';
import DailyTarget from './component/DailyTarget';
import Week from './component/Week';
import {SActionBtn, SDrawerOrModal, SLowcodeList, STableActions, STriggerModal} from 'shj-components';
import {httpAchievementDate, httpAchievementSaveOrUpdate} from '@/services/customerServices';
import AddOrEdit from './component/AddOrEdit';
import {fetchCompany, fetchList, fetchTypes} from './funs';
import {useMount} from 'ahooks';
import dayjs from 'dayjs'

import styles from './index.module.less'

function AchievementDate() {
  const listRef = useRef<any>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDailyVisible, setIsDailyVisible] = useState(false);
  const [rowData, setRowData] = useState();
  const [isWeekVisible, setIsWeekVisible] = useState(false);
  const [weekRowData, setWeekRowData] = useState();
  const [company, setCompany] = useState([]);
  const [types, setTypes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false)
  const [modalLoading, setModalLoading] = useState(false)
  const formRef: Ref<any> = useRef()
  const [choseData, setChoseData] = useState(null);

  const getSelect = () => {
    return new Promise((resolve) => {
      const _year = {'-1': '不限'};
      for (let i = 2000; i < 2050; i++) {
        _year[i] = i;
      }
      const _month = {'-1': '不限'};
      for (let i = 1; i < 13; i++) {
        _month[i] = i;
      }
      resolve({
        yearData: _year,
        monthData: _month,
      });
    });
  };

  /**
   * 添加
   */
  const onAdd = useCallback(() => {
    const form: FormInstance = formRef.current?.onFormRef()
    form.resetFields();
    form.setFieldsValue({id: undefined});
    setIsModalVisible(true);
  }, []);

  /**
   * 编辑
   * @param record
   */
  const onEdit = async (record: any) => {
    if (loading) {
      return
    }
    setChoseData(record);
    try {
      const form = formRef.current?.onFormRef()
      setLoading(true)
      setIsModalVisible(true);
      const resData: any = await httpAchievementDate({id: record.id})
      const data = resData;

      const _data = {
        ...data,
        yearMonth: dayjs(data.year + '-' + data.month),
        startDate: dayjs(data.startDate),
        endDate: dayjs(data.endDate),
      };
      if (_data?.suitCompanys) {
        _data.suitCompanys.forEach((v: string, index: number, arr: any) => {
          arr[index] = v;
        });
      } else {
        _data.suitCompanys = []
      }
      // console.log(data, _data);
      form.setFieldsValue(_data);
      setLoading(false)
    } catch (error) {
      setLoading(false)
      // console.log('error', error);
    }
  };

  /**
   * 同步周期配置
   * @param {object} record - 表格row
   */
  const onWeekEdit = (record: any) => {
    setIsWeekVisible(true);
    setWeekRowData(record);
  };
  /**
   * 同步日配置
   * @param {object} record - 表格row
   */
  const onDailyEdit = (record: any) => {
    setIsDailyVisible(true);
    setRowData(record);
  };

  const extension = {
    request: {fetchList, getSelect},
    events: {onAdd},
    customRender: {
      actionTool(text: string, record: object) {
        return (
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>
                编辑
              </SActionBtn>
              <SActionBtn onClick={() => onWeekEdit(record)}>
                周次配置
              </SActionBtn>
              <SActionBtn onClick={() => onDailyEdit(record)}>
                日目标配置
              </SActionBtn>
            </STableActions>
        );
      },
      monthRender() {
        return <DatePicker style={{width: '100%'}}
                           format={'M'}
                           picker={'month'}
                           panelRender={(panelNode) => <div className={styles.monthPickerBox}>{panelNode}</div>}
        />
      }
    },
  };

  /**
   * 新增/编辑提交
   * @param {object} value - 表单数据
   * @returns
   */
  const onFinish = (value: any) => {
    const _value = {...value};
    _value.yearMonth = dayjs(_value.yearMonth).format('YYYY-MM');
    [_value.year, _value.month] = _value.yearMonth.split('-');
    const diff = _value.endDate.diff(_value.startDate, 'seconds');
    if (diff <= 0) {
      message.error('目标业绩开始时间应小于结束时间');
      return;
    }
    _value.startDate = dayjs(_value.startDate).format('YYYY-MM-DD HH:mm:ss');
    _value.endDate = dayjs(_value.endDate).format('YYYY-MM-DD HH:mm:ss');
    // console.log(_value);
    delete _value.yearMonth;

    // return;
    setModalLoading(true)
    httpAchievementSaveOrUpdate({data: _value, method: 'POST'}).then(() => {
      message.success('操作成功');
      setIsModalVisible(false);
      setModalLoading(false);
      setChoseData(null);
      listRef.current.reload();
    }).catch(() => {
      setModalLoading(false)
    })
  };

  /**
   * modal 确定
   */
  const onOk = () => {
    const form = formRef.current?.onFormRef()
    form.validateFields().then((value: any) => {
      onFinish(value)
    })
  };

  /**
   * 关闭modal
   */
  const onCancel = useCallback(() => {
    setChoseData(null);
    setIsModalVisible(false);
  }, []);

  useMount(() => {
    fetchCompany(setCompany);
    fetchTypes(setTypes)
  });

  return (
      <>
        <SLowcodeList listTitle="业绩期管理列表" config={config} ref={listRef} {...extension} />
        {/* <STriggerModal width={600} confirmLoading={modalLoading || loading} forceRender cancelText="取消"
                       title={choseData?.id ? '编辑' : '新增'} destroyOnClose={true} onCancel={onCancel} onOk={onOk}
                       open={isModalVisible}> */}
      <SDrawerOrModal
        title={choseData?.id ? '编辑' : '新增'}
        onCancel={onCancel}
        onOk={onOk}
        open={isModalVisible}
        antdProps={{ destroyOnClose: true }}
      >              
          <AddOrEdit
              onFinish={onFinish}
              typesList={types}
              companyList={company}
              ref={formRef}
              choseData={choseData}
          />
        </SDrawerOrModal> 
        {/* 日目标配置 */}
        <DailyTarget isVisible={isDailyVisible} rowData={rowData} setIsVisible={setIsDailyVisible}/>
        {/* 周次配置 */}
        <Week isVisible={isWeekVisible} rowData={weekRowData} setIsVisible={setIsWeekVisible}/>
      </>
  );
}

export default AchievementDate;
